// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--bjwBx","title":"a10a3f92e9--title--DnH9v","text":"a10a3f92e9--text--7dN40"};